/**
 * 资源管理相关
 */
import axios from '../../utils/axios'

// 列出名下监控商品
export function page_list(data) {
    return axios({
        url: '/admin/keyword_tracker/product/page_list', method: 'POST', data: data
    })
}

// 删除商品
export function product_delete(data) {
    return axios({
        url: '/admin/keyword_tracker/product/delete', method: 'POST', data: data
    })
}

// 设置商品置顶标识
export function important(data) {
    return axios({
        url: '/admin/keyword_tracker/product/important', method: 'POST', data: data
    })
}

// 设置竞品ASIN
export function competitors(data) {
    return axios({
        url: '/admin/keyword_tracker/product/competitors', method: 'POST', data: data
    })
}

// 添加商品关键词
export function add_keywords(data) {
    return axios({
        url: '/admin/keyword_tracker/product/add_keywords', method: 'POST', data: data
    })
}

// 商品的关键词列表返回
export function keywords(data) {
    return axios({
        url: '/admin/keyword_tracker/product/keywords', method: 'POST', data: data
    })
}

// 修改关键词列表
export function mod_keyword(data) {
    return axios({
        url: '/admin/keyword_tracker/product/mod_keyword', method: 'POST', data: data
    })
}

// 添加商品前根据ASIN或者URL获得信息
export function asin_info(data) {
    return axios({
        url: '/admin/keyword_tracker/product/asin_info', method: 'POST', data: data
    })
}

// 获得所有asin的关键词列表
export function keywords_of_all_asins(data) {
    return axios({
        url: '/admin/keyword_tracker/product/keywords_of_all_asins', method: 'POST', data: data
    })
}

// 添加商品
export function product_add(data) {
    return axios({
        url: '/admin/keyword_tracker/product/add', method: 'POST', data: data
    })
}

// 关键词数量统计
export function limitation(data) {
    return axios({
        url: '/admin/keyword_tracker/keyword/limitation', method: 'POST', data: data
    })
}

// 获得所有子ASIN变体
export function variations(data) {
    return axios({
        url: '/admin/keyword_tracker/product/variations', method: 'POST', data: data
    })
}

// 更新子asin列表
export function update_sub_asin(data) {
    return axios({
        url: '/admin/keyword_tracker/product/update_sub_asin', method: 'POST', data: data
    })
}

// 商品下的关键词列表
export function keyword_page_list(data) {
    return axios({
        url: '/admin/keyword_tracker/keyword/page_list', method: 'POST', data: data
    })
}

// 获取关键词标签列表
export function keyword_tags(data) {
    return axios({
        url: '/admin/keyword_tracker/keyword/tags', method: 'POST', data: data
    })
}

// 给关键词打标签
export function tag_keyword(data) {
    return axios({
        url: '/admin/keyword_tracker/keyword/tag_keyword', method: 'POST', data: data
    })
}

// 给标签添加备注
export function remark_tag(data) {
    return axios({
        url: '/admin/keyword_tracker/keyword/remark_tag', method: 'POST', data: data
    })
}

// 删除关键词记录
export function remark_remove(data) {
    return axios({
        url: '/admin/keyword_tracker/keyword/remove', method: 'POST', data: data
    })
}

// 添加关键词组（文件夹）
export function kw_folder_add(data) {
    return axios({
        url: '/admin/keyword_tracker/kw_folder/add', method: 'POST', data: data
    })
}

// 列出关键词组（文件夹）
export function kw_folder_all(data) {
    return axios({
        url: '/admin/keyword_tracker/kw_folder/all', method: 'POST', data: data
    })
}

// 将关键词加入组
export function put_keyword(data) {
    return axios({
        url: '/admin/keyword_tracker/kw_folder/put_keyword', method: 'POST', data: data
    })
}

// 组（文件夹）内关键词列表分页
export function kw_folder_keywords(data) {
    return axios({
        url: '/admin/keyword_tracker/kw_folder/keywords', method: 'POST', data: data
    })
}

// 组（文件夹）内关键词列表
export function keywords_by_id(data) {
    return axios({
        url: '/admin/keyword_tracker/kw_folder/keywords_by_id', method: 'POST', data: data
    })
}

// 删除组（文件夹）内关键词
export function rm_keywords(data) {
    return axios({
        url: '/admin/keyword_tracker/kw_folder/rm_keywords', method: 'POST', data: data
    })
}

// 删除组（文件夹）
export function kw_folder_remove(data) {
    return axios({
        url: '/admin/keyword_tracker/kw_folder/remove', method: 'POST', data: data
    })
}

// 编辑组（文件夹）名字
export function kw_folder_edit(data) {
    return axios({
        url: '/admin/keyword_tracker/kw_folder/edit', method: 'POST', data: data
    })
}

// 批量获得关键词趋势数据
export function trend_batch(data) {
    return axios({
        url: '/admin/keyword_tracker/keyword/trend_batch', method: 'POST', data: data
    })
}

// 获取竞品排名信息
export function competitors_ranking(data) {
    return axios({
        url: '/admin/keyword_tracker/product/competitors_ranking', method: 'POST', data: data
    })
}

// 批量获取关键词跟竞品相对排名趋势
export function competitors_relative_trend_batch(data) {
    return axios({
        url: '/admin/keyword_tracker/keyword/competitors_relative_trend_batch', method: 'POST', data: data
    })
}

// 批量获取关键词跟竞品进入搜索排名的数量趋势
export function competitors_in_rank_trend_batch(data) {
    return axios({
        url: '/admin/keyword_tracker/keyword/competitors_in_rank_trend_batch', method: 'POST', data: data
    })
}

// 关键词加备注
export function remark(data) {
    return axios({
        url: '/admin/keyword_tracker/keyword/remark', method: 'POST', data: data
    })
}

// 批量导入关键词备注
export function batch_remark(data) {
    return axios({
        url: '/admin/keyword_tracker/keyword/batch_remark', method: 'POST', data: data
    })
}

// 给关键词的特定日期添加备注
export function remark_in_date(data) {
    return axios({
        url: '/admin/keyword_tracker/keyword/remark_in_date', method: 'POST', data: data
    })
}

// 商品数据统计接口
export function statistics(data) {
    return axios({
        url: '/admin/keyword_tracker/product/statistics', method: 'POST', data: data
    })
}

// 获取关键词数量上限变化记录
export function get_keyword_sum_record(data) {
    return axios({
        url: '/admin/keyword_tracker/keyword/get_keyword_sum_record', method: 'POST', data: data
    })
}

// 关键词搜索趋势图
export function search_trend_batch(data) {
    return axios({
        url: '/admin/keyword_tracker/keyword_search/search_trend_batch', method: 'POST', data: data
    })
}

// 关键词搜索趋势图-月
export function search_trend_batch_by_month(data) {
    return axios({
        url: '/admin/keyword_tracker/keyword_search/search_trend_batch_by_month', method: 'POST', data: data
    })
}


// 导入搜索词数据-月
export function import_search_term_share_by_month(data) {
    return axios({
        url: '/admin/keyword_tracker/keyword_search/import_search_term_share_by_month', method: 'POST', data: data
    })
}

// 导入搜索词数据
export function import_search_term_share(data) {
    return axios({
        url: '/admin/keyword_tracker/keyword_search/import_search_term_share', method: 'POST', data: data
    })
}

// 管理员--列出用户名下监控商品
export function page_lists(data) {
    return axios({
        url: '/admin/keyword_tracker/product/page_lists', method: 'POST', data: data
    })
}

// 管理员--获取关键词标签列表
export function user_tags(data) {
    return axios({
        url: '/admin/keyword_tracker/keyword/user_tags', method: 'POST', data: data
    })
}

// 管理员--关键词搜索趋势图
export function search_trend_batchs(data) {
    return axios({
        url: '/admin/keyword_tracker/keyword_search/search_trend_batchs', method: 'POST', data: data
    })
}

// 手动更新关键词统计数据
export function beginKeywordUpdateByHand(data) {
    return axios({
        url: '/admin/keyword_tracker/keyword/beginKeywordUpdateByHand', method: 'POST', data: data
    })
}

// 关键词搜索数据列表
export function keyword_search_page_list(data) {
    return axios({
        url: '/admin/keyword_tracker/keyword_search/page_list', method: 'POST', data: data
    })
}

// 导出最近搜索词数据
export function export_last_search_data(data) {
    return axios({
        url: '/admin/keyword_tracker/keyword_search/export_last_search_data', method: 'POST', data: data
    })
}

// 导出搜索词数据
export function export_search_data(data) {
    return axios({
        url: '/admin/keyword_tracker/keyword_search/export_search_data', method: 'POST', data: data
    })
}

// 导入SB关键词搜索日数据
export function sb_import_file(data) {
    return axios({
        url: '/admin/keyword_tracker/sb_keyword_search/import_file', method: 'POST', data: data
    })
}

// SB关键词搜索日趋势列表
export function sb_page_list(data) {
    return axios({
        url: '/admin/keyword_tracker/sb_keyword_search/page_list', method: 'POST', data: data
    })
}

// SB关键词搜索日趋势图
export function sb_search_trend(data) {
    return axios({
        url: '/admin/keyword_tracker/sb_keyword_search/sb_search_trend', method: 'POST', data: data
    })
}

// 导出SB关键词搜索日数据
export function sb_export_file(data) {
    return axios({
        url: '/admin/keyword_tracker/sb_keyword_search/export_file', method: 'POST', data: data
    })
}


// 上传SB广告组广告位文件
export function sb_upload_source_file(data) {
    return axios({
        url: '/admin/variety/sb_ad_position_analysis/upload_source_file', method: 'POST', data: data
    })
}

// SB广告组广告位文件解析列表
export function sb_analysis_list(data) {
    return axios({
        url: '/admin/variety/sb_ad_position_analysis/index', method: 'POST', data: data
    })
}

// 添加SB广告组广告位文件解析记录
export function sb_ad_position_analysis_add(data) {
    return axios({
        url: '/admin/variety/sb_ad_position_analysis/add', method: 'POST', data: data
    })
}

// 删除SB广告组广告位文件解析记录
export function sb_ad_position_analysis_delete(data) {
    return axios({
        url: '/admin/variety/sb_ad_position_analysis/delete', method: 'POST', data: data
    })
}

// B广告组广告位文件-解析文件
export function sb_ad_position_analysis_parsing_file(data) {
    return axios({
        url: '/admin/variety/sb_ad_position_analysis/parsing_file', method: 'POST', data: data
    })
}

// SB|SBV Ad

// SB|SBV广告组合解析列表
export function sb_sbv_portfolio_parse_list(data) {
    return axios({
        url: '/admin/keyword_tracker/sb_ad/sb_sbv_portfolio_parse_list', method: 'POST', data: data
    })
}

// 上传SB种子词数据列表
export function upload_source_file_list(data) {
    return axios({
        url: '/admin/keyword_tracker/sb_ad/upload_source_file_list', method: 'POST', data: data
    })
}

// 上传SB种子词数据
export function upload_source_file(data) {
    return axios({
        url: '/admin/keyword_tracker/sb_ad/upload_source_file', method: 'POST', data: data
    })
}

// SD

export function upload_source_file_SD(data) {
    return axios({
        url: '/admin/keyword_tracker/sd_ad/upload_source_file', method: 'POST', data: data
    })
}

// 上传SD种子词数据列表
export function upload_source_file_list_SD(data) {
    return axios({
        url: '/admin/keyword_tracker/sd_ad/upload_source_file_list', method: 'POST', data: data
    })
}


// SD广告组合解析列表
export function sd_portfolio_parse_list(data) {
    return axios({
        url: '/admin/keyword_tracker/sd_ad/sd_portfolio_parse_list', method: 'POST', data: data
    })
}


// SB种子词广告组最新解析列表
export function sb_ad_lastest_campaign_update_list(data) {
    return axios({
        url: '/admin/keyword_tracker/sb_ad/lastest_campaign_update_list', method: 'POST', data: data
    })
}

// SD种子词广告组最新解析列表
export function sd_ad_lastest_campaign_update_list(data) {
    return axios({
        url: '/admin/keyword_tracker/sd_ad/lastest_campaign_update_list', method: 'POST', data: data
    })
}

export function ara_index_list(data) {
    return axios({
        url: '/admin/ara/index/list', method: 'POST', data: data
    })
}

export function ara_index_trend_batch(data) {
    return axios({
        url: '/admin/ara/index/trend_batch', method: 'POST', data: data
    })
}

// 上传SP广告搜索词报告
export function sp_ad_upload_source_file(data) {
    return axios({
        url: '/admin/keyword_tracker/sp_ad/upload_source_file', method: 'POST', data: data
    })
}

// 上传源文件列表
export function sp_ad_upload_source_file_list(data) {
    return axios({
        url: '/admin/keyword_tracker/sp_ad/upload_source_file_list', method: 'POST', data: data
    })
}

// SP搜索词报告列表
export function sp_ad_list(data) {
    return axios({
        url: '/admin/keyword_tracker/sp_ad/list', method: 'POST', data: data
    })
}

// 删除单条记录
export function sp_ad_delete(data) {
    return axios({
        url: '/admin/keyword_tracker/sp_ad/delete', method: 'POST', data: data
    })
}

// SP搜索词报告指定日期导出
export function sp_ad_export_file(data) {
    return axios({
        url: '/admin/keyword_tracker/sp_ad/export_file', method: 'POST', data: data
    })
}

// 种子词库列表
export function seed_word_asin_list(data) {
    return axios({
        url: '/admin/seed_word/asin/list', method: 'POST', data: data
    })
}

// 种子词库列表
export function seed_word_asin_get_three_page_total(data) {
    return axios({
        url: '/admin/seed_word/asin/get_three_page_total', method: 'POST', data: data
    })
}


// 已打广告词数据-列表
export function seed_word_ad_word_list(data) {
    return axios({
        url: '/admin/seed_word/ad_word/list', method: 'POST', data: data
    })
}

// 已打广告词数据-批量删除记录
export function seed_word_ad_word_delete(data) {
    return axios({
        url: '/admin/seed_word/ad_word/delete', method: 'POST', data: data
    })
}

// 已打广告词数据-导出
export function seed_word_ad_word_export(data) {
    return axios({
        url: '/admin/seed_word/ad_word/export', method: 'POST', data: data
    })
}

// 否定词根数据-列表
export function seed_word_disavowal_root_word_list(data) {
    return axios({
        url: '/admin/seed_word/disavowal_root_word/list', method: 'POST', data: data
    })
}

// 否定词根数据-批量删除记录
export function seed_word_disavowal_root_word_delete(data) {
    return axios({
        url: '/admin/seed_word/disavowal_root_word/delete', method: 'POST', data: data
    })
}

// 否定词根数据-导出
export function seed_word_disavowal_root_word_export(data) {
    return axios({
        url: '/admin/seed_word/disavowal_root_word/export', method: 'POST', data: data
    })
}

// 无效词数据-列表
export function seed_word_invalid_word_list(data) {
    return axios({
        url: '/admin/seed_word/invalid_word/list', method: 'POST', data: data
    })
}

// 无效词数据-批量删除记录
export function seed_word_invalid_word_delete(data) {
    return axios({
        url: '/admin/seed_word/invalid_word/delete', method: 'POST', data: data
    })
}

// 词根数据-列表
export function seed_word_root_word_list(data) {
    return axios({
        url: '/admin/seed_word/root_word/list', method: 'POST', data: data
    })
}

// 词根数据-批量删除记录
export function seed_word_root_word_delete(data) {
    return axios({
        url: '/admin/seed_word/root_word/delete', method: 'POST', data: data
    })
}

// 词根数据-导出
export function seed_word_root_word_export(data) {
    return axios({
        url: '/admin/seed_word/root_word/export', method: 'POST', data: data
    })
}


// 对比Asin数据-列表
export function seed_word_compare_asin_list(data) {
    return axios({
        url: '/admin/seed_word/compare_asin/list', method: 'POST', data: data
    })
}

// 对比Asin数据-批量删除记录
export function seed_word_compare_asin_delete(data) {
    return axios({
        url: '/admin/seed_word/compare_asin/delete', method: 'POST', data: data
    })
}

// 核心词根数据-列表
export function seed_word_core_word_list(data) {
    return axios({
        url: '/admin/seed_word/core_word/list', method: 'POST', data: data
    })
}

// 核心词根数据-批量删除记录
export function seed_word_core_word_delete(data) {
    return axios({
        url: '/admin/seed_word/core_word/delete', method: 'POST', data: data
    })
}

// 核心词根数据-导出
export function seed_word_core_word_export(data) {
    return axios({
        url: '/admin/seed_word/core_word/export', method: 'POST', data: data
    })
}

// 词库排除数据-列表
export function seed_word_eliminate_word_list(data) {
    return axios({
        url: '/admin/seed_word/eliminate_word/list', method: 'POST', data: data
    })
}

// 词库排除数据-批量删除记录
export function seed_word_eliminate_word_delete(data) {
    return axios({
        url: '/admin/seed_word/eliminate_word/delete', method: 'POST', data: data
    })
}


// 否定词根数据-导入
export function disavowal_root_word_import(data) {
    return axios({
        url: '/admin/seed_word/disavowal_root_word/import', method: 'POST', data: data
    })
}

// 已打广告词数据-导入
export function ad_word_import(data) {
    return axios({
        url: '/admin/seed_word/ad_word/import', method: 'POST', data: data
    })
}

// 无效词数据-导入
export function invalid_word_import(data) {
    return axios({
        url: '/admin/seed_word/invalid_word/import', method: 'POST', data: data
    })
}

// 词库排除数据-导入
export function eliminate_word_import(data) {
    return axios({
        url: '/admin/seed_word/eliminate_word/import', method: 'POST', data: data
    })
}

// 核心词根数据-导入
export function core_word_import(data) {
    return axios({
        url: '/admin/seed_word/core_word/import', method: 'POST', data: data
    })
}


// 种子词库-列表
export function seed_thesaurus_list(data) {
    return axios({
        url: '/admin/seed_word/seed_thesaurus/list', method: 'POST', data: data
    })
}

// 种子词库-列表
export function seed_thesaurus_import(data) {
    return axios({
        url: '/admin/seed_word/seed_thesaurus/import', method: 'POST', data: data
    })
}

// 种子词库-批量删除记录
export function seed_thesaurus_delete(data) {
    return axios({
        url: '/admin/seed_word/seed_thesaurus/delete', method: 'POST', data: data
    })
}

// 种子词库-生成最新Excel
export function seed_thesaurus_create_excel_file(data) {
    return axios({
        url: '/admin/seed_word/seed_thesaurus/create_excel_file', method: 'POST', data: data
    })
}

// 种子词库-下载列表
export function seed_thesaurus_download_excel_list(data) {
    return axios({
        url: '/admin/seed_word/seed_thesaurus/download_excel_list', method: 'POST', data: data
    })
}


// 修改备注
export function asin_update_remark(data) {
    return axios({
        url: '/admin/seed_word/asin/update_remark', method: 'POST', data: data
    })
}

// 修改负责人
export function asin_update_res_person(data) {
    return axios({
        url: '/admin/seed_word/asin/update_res_person', method: 'POST', data: data
    })
}


// 获取广告组合列表
export function asin_get_portfolio_list(data) {
    return axios({
        url: '/admin/seed_word/asin/get_portfolio_list', method: 'POST', data: data
    })
}

// 绑定广告组合名称
export function asin_set_portfolio_name(data) {
    return axios({
        url: '/admin/seed_word/asin/set_portfolio_name', method: 'POST', data: data
    })
}

// 上传关键词搜索数据源文件列表
export function keyword_search_upload_source_file_list(data) {
    return axios({
        url: '/admin/keyword_tracker/keyword_search/upload_source_file_list', method: 'POST', data: data
    })
}

// 对比Asin数据-生成最新excel
export function compare_asin_create_excel_file(data) {
    return axios({
        url: '/admin/seed_word/compare_asin/create_excel_file', method: 'POST', data: data
    })
}

export function compare_asin_download_excel_list(data) {
    return axios({
        url: '/admin/seed_word/compare_asin/download_excel_list', method: 'POST', data: data
    })
}


export function sb_keyword_search_upload_source_file_list(data) {
    return axios({
        url: '/admin/keyword_tracker/sb_keyword_search/upload_source_file_list', method: 'POST', data: data
    })
}


export function asin_add(data) {
    return axios({
        url: '/admin/seed_word/asin/add', method: 'POST', data: data
    })
}

// 店铺名称数据-列表
export function shop_name_index(data) {
    return axios({
        url: '/admin/common/shop_name/index', method: 'POST', data: data
    })
}

// 店铺名称数据-列表
export function shop_name_list(data) {
    return axios({
        url: '/admin/common/shop_name/list', method: 'POST', data: data
    })
}

// 店铺名称数据-添加
export function shop_name_add(data) {
    return axios({
        url: '/admin/common/shop_name/add', method: 'POST', data: data
    })
}

// 店铺名称数据-删除
export function shop_name_delete(data) {
    return axios({
        url: '/admin/common/shop_name/delete', method: 'POST', data: data
    })
}

// Sb合理性分析-列表
export function sb_rationality_analysis_index(data) {
    return axios({
        url: '/admin/ad_for_sb/sb_rationality_analysis/index', method: 'POST', data: data
    })
}

// Sb合理性分析-添加解析记录
export function sb_rationality_analysis_add(data) {
    return axios({
        url: '/admin/ad_for_sb/sb_rationality_analysis/add', method: 'POST', data: data
    })
}

// Sb合理性分析-解析文件
export function sb_rationality_analysis_parsing_file(data) {
    return axios({
        url: '/admin/ad_for_sb/sb_rationality_analysis/parsing_file', method: 'POST', data: data
    })
}

// Sb合理性分析-删除单条记录
export function sb_rationality_analysis_delete(data) {
    return axios({
        url: '/admin/ad_for_sb/sb_rationality_analysis/delete', method: 'POST', data: data
    })
}

// Sb前置否定-解析文件
export function sb_predisavowal_parsing_file(data) {
    return axios({
        url: '/admin/ad_for_sb/sb_predisavowal/parsing_file', method: 'POST', data: data
    })
}

// Sb内部竞价优化-解析文件
export function sb_bid_optimization_parsing_file(data) {
    return axios({
        url: '/admin/ad_for_sb/sb_bid_optimization/parsing_file', method: 'POST', data: data
    })
}


// Sb降bid-列表
export function sb_reduce_bid_index(data) {
    return axios({
        url: '/admin/ad_for_sb/sb_reduce_bid/index', method: 'POST', data: data
    })
}

// Sb降bid-添加记录
export function sb_reduce_bid_add(data) {
    return axios({
        url: '/admin/ad_for_sb/sb_reduce_bid/add', method: 'POST', data: data
    })
}

// Sb降bid-删除记录
export function sb_reduce_bid_delete(data) {
    return axios({
        url: '/admin/ad_for_sb/sb_reduce_bid/delete', method: 'POST', data: data
    })
}

// Sb降bid-解析记录
export function sb_reduce_bid_parsing_file(data) {
    return axios({
        url: '/admin/ad_for_sb/sb_reduce_bid/parsing_file', method: 'POST', data: data
    })
}


// Asin跟踪-列表
export function track_asin_index_index(data) {
    return axios({
        url: '/admin/track_asin/index/index', method: 'POST', data: data
    })
}

// Asin跟踪-更新备注
export function track_asin_index_update_remark(data) {
    return axios({
        url: '/admin/track_asin/index/update_remark', method: 'POST', data: data
    })
}

// Asin跟踪-更新负责人
export function track_asin_index_update_person(data) {
    return axios({
        url: '/admin/track_asin/index/update_person', method: 'POST', data: data
    })
}

// Asin跟踪-更换店铺
export function track_asin_index_update_shop_name(data) {
    return axios({
        url: '/admin/track_asin/index/update_shop_name', method: 'POST', data: data
    })
}

// Asin跟踪-添加
export function track_asin_index_add(data) {
    return axios({
        url: '/admin/track_asin/index/add', method: 'POST', data: data
    })
}

// Asin跟踪-更新信息
export function track_asin_index_add_redis_for_parent_asin_base_message(data) {
    return axios({
        url: '/admin/track_asin/index/add_redis_for_parent_asin_base_message', method: 'POST', data: data
    })
}

// Asin跟踪-删除记录
export function track_asin_index_delete(data) {
    return axios({
        url: '/admin/track_asin/index/delete', method: 'POST', data: data
    })
}

// Asin跟踪-导出
export function track_asin_index_export(data) {
    return axios({
        url: '/admin/track_asin/index/export', method: 'POST', data: data
    })
}

// Asin跟踪-导出
export function track_asin_index_change_trend(data) {
    return axios({
        url: '/admin/track_asin/index/change_trend', method: 'POST', data: data
    })
}

// Asin跟踪-更新品牌
export function track_asin_index_update_brand(data) {
    return axios({
        url: '/admin/track_asin/index/update_brand', method: 'POST', data: data
    })
}

// 子Asin跟踪-列表
export function track_asin_sub_index(data) {
    return axios({
        url: '/admin/track_asin/sub/index', method: 'POST', data: data
    })
}

// 子Asin跟踪-ratings|reviews变化趋势
export function track_asin_sub_change_trend(data) {
    return axios({
        url: '/admin/track_asin/sub/change_trend', method: 'POST', data: data
    })
}

// 子Asin跟踪-子asin导出
export function track_asin_sub_export(data) {
    return axios({
        url: '/admin/track_asin/sub/export', method: 'POST', data: data
    })
}

// 子Asin跟踪-价格趋势
export function track_asin_sub_get_price_trend(data) {
    return axios({
        url: '/admin/track_asin/sub/get_price_trend', method: 'POST', data: data
    })
}

// 子Asin跟踪-评价列表
export function sub_get_sub_asin_negative_comment_list_list(data) {
    return axios({
        url: '/admin/track_asin/sub/get_sub_asin_negative_comment_list', method: 'POST', data: data
    })
}

// 子Asin跟踪-插件更新价格趋势
export function callback_track_task_update_sub_asin_price_message(data) {
    return axios({
        url: '/callback/track_task/update_sub_asin_price_message', method: 'POST', data: data
    })
}

// Asin跟踪-是否钉钉提醒
export function track_asin_index_update_dingding_warn(data) {
    return axios({
        url: '/admin/track_asin/index/update_dingding_warn', method: 'POST', data: data
    })
}

// 子Asin跟踪-设为主Asin
export function track_asin_sub_update_is_main(data) {
    return axios({
        url: '/admin/track_asin/sub/update_is_main', method: 'POST', data: data
    })
}

// 成本控制分析-批量添加解析数据
export function cost_control_analysis_batch_add_parse_datas(data) {
    return axios({
        url: '/admin/variety/cost_control_analysis/batch_add_parse_datas', method: 'POST', data: data
    })
}

// 成本控制分析-批量添加解析数据
export function cost_control_analysis_update(data) {
    return axios({
        url: '/admin/variety/cost_control_analysis/update', method: 'POST', data: data
    })
}

// 成本控制分析-修改指定字段
export function cost_control_analysis_update_field(data) {
    return axios({
        url: '/admin/variety/cost_control_analysis/update_field', method: 'POST', data: data
    })
}

// 子Asin跟踪-子asin详情导出
export function track_asin_sub_sub_price_asin_details_export(data) {
    return axios({
        url: '/admin/track_asin/sub/sub_price_asin_details_export', method: 'POST', data: data
    })
}

// 查询Asin关键词排名数据
export function seed_word_asin_keyword_get_detail_list(data) {
    return axios({
        url: '/admin/seed_word/asin_keyword/get_detail_list', method: 'POST', data: data
    })
}

// 关键词排名数据文件列表
export function seed_word_asin_keyword_get_excel_list(data) {
    return axios({
        url: '/admin/seed_word/asin_keyword/get_excel_list', method: 'POST', data: data
    })
}

//
export function seed_word_asin_keyword_import(data) {
    return axios({
        url: '/admin/seed_word/asin_keyword/import', method: 'POST', data: data
    })
}

//
export function set_sp_ad_extra_config_import_bad_keywords(data) {
    return axios({
        url: '/admin/ad_for_sp/base/import_bad_keywords', method: 'POST', data: data
    })
}

export function seed_word_asin_keyword_delete(data) {
    return axios({
        url: '/admin/seed_word/asin_keyword/delete', method: 'POST', data: data
    })
}

export function seed_word_asin_get_detail(data) {
    return axios({
        url: '/admin/seed_word/asin/get_detail', method: 'POST', data: data
    })
}


// 种子词库-列表-管理员数据列表
export function seed_word_asin_list_manager_lists(data) {
    return axios({
        url: '/admin/seed_word/asin_list/manager_lists', method: 'POST', data: data
    })
}


// 种子词库-列表-运营人员数据列表
export function seed_word_asin_list_operator_lists(data) {
    return axios({
        url: '/admin/seed_word/asin_list/operator_lists', method: 'POST', data: data
    })
}


// 种子词库-列表-添加Asin
export function seed_word_asin_list_add(data) {
    return axios({
        url: '/admin/seed_word/asin_list/add', method: 'POST', data: data
    })
}


// 种子词库-列表-更新字段
export function seed_word_asin_list_update_field(data) {
    return axios({
        url: '/admin/seed_word/asin_list/update_field', method: 'POST', data: data
    })
}

// 种子词库-列表-获取广告组合列表
export function seed_word_asin_list_get_portfolio_list(data) {
    return axios({
        url: '/admin/seed_word/asin_list/get_portfolio_list', method: 'POST', data: data
    })
}

// 种子词库-列表-绑定广告组合
export function seed_word_asin_list_bind_asin_portfolio(data) {
    return axios({
        url: '/admin/seed_word/asin_list/bind_asin_portfolio', method: 'POST', data: data
    })
}


// 种子词库-词根 - 列表
export function seed_word_etyma_lists(data) {
    return axios({
        url: '/admin/seed_word/etyma/lists', method: 'POST', data: data
    })
}


// 种子词库-词根 - 导入
export function seed_word_etyma_import(data) {
    return axios({
        url: '/admin/seed_word/etyma/import', method: 'POST', data: data
    })
}


// 种子词库-词根 - 导出
export function seed_word_etyma_export(data) {
    return axios({
        url: '/admin/seed_word/etyma/export', method: 'POST', data: data
    })
}


// 种子词库-词根 - 删除
export function seed_word_etyma_delete(data) {
    return axios({
        url: '/admin/seed_word/etyma/deleted', method: 'POST', data: data
    })
}


// 种子词库-否定词根 - 列表
export function seed_word_negative_etyma_lists(data) {
    return axios({
        url: '/admin/seed_word/negative_etyma/lists', method: 'POST', data: data
    })
}


// 种子词库-否定词根 - 导入
export function seed_word_negative_etyma_import(data) {
    return axios({
        url: '/admin/seed_word/negative_etyma/import', method: 'POST', data: data
    })
}


// 种子词库-否定词根 - 导出
export function seed_word_negative_etyma_export(data) {
    return axios({
        url: '/admin/seed_word/negative_etyma/export', method: 'POST', data: data
    })
}


// 种子词库-否定词根 - 删除
export function seed_word_negative_etyma_delete(data) {
    return axios({
        url: '/admin/seed_word/negative_etyma/deleted', method: 'POST', data: data
    })
}


// 种子词库-流量词 - 列表
export function seed_word_traffic_word_lists(data) {
    return axios({
        url: '/admin/seed_word/traffic_word/lists', method: 'POST', data: data
    })
}

// 种子词库-流量词 -删除
export function seed_word_traffic_word_delete(data) {
    return axios({
        url: '/admin/seed_word/traffic_word/deleted', method: 'POST', data: data
    })
}

// 种子词库-流量词 - 导入
export function seed_word_traffic_word_import(data) {
    return axios({
        url: '/admin/seed_word/traffic_word/import', method: 'POST', data: data
    })
}


// 种子词库-流量词 - 生成最新Excel
export function seed_word_traffic_word_create_excel_file(data) {
    return axios({
        url: '/admin/seed_word/traffic_word/create_excel_file', method: 'POST', data: data
    })
}

// 种子词库-流量词 - 下载列表
export function seed_word_traffic_word_download_excel_file(data) {
    return axios({
        url: '/admin/seed_word/traffic_word/download_excel_list', method: 'POST', data: data
    })
}


// 种子词库-已打广告词 - 列表
export function seed_word_advertised_word_lists(data) {
    return axios({
        url: '/admin/seed_word/advertised_word/lists', method: 'POST', data: data
    })
}


// 种子词库-已打广告词 - 导入
export function seed_word_advertised_word_import(data) {
    return axios({
        url: '/admin/seed_word/advertised_word/import', method: 'POST', data: data
    })
}


// 种子词库-已打广告词 - 导出
export function seed_word_advertised_word_export(data) {
    return axios({
        url: '/admin/seed_word/advertised_word/export', method: 'POST', data: data
    })
}


// 种子词库-已打广告词 - 删除
export function seed_word_advertised_word_delete(data) {
    return axios({
        url: '/admin/seed_word/advertised_word/deleted', method: 'POST', data: data
    })
}

// 种子词库-无效词 - 列表
export function seed_word_invalid_word_lists(data) {
    return axios({
        url: '/admin/seed_word/invalid_word/lists', method: 'POST', data: data
    })
}


// 种子词库-无效词 - 导入
export function seed_word_invalid_word_import(data) {
    return axios({
        url: '/admin/seed_word/invalid_word/import', method: 'POST', data: data
    })
}


// 种子词库-无效词 - 导出
export function seed_word_invalid_word_export(data) {
    return axios({
        url: '/admin/seed_word/invalid_word/export', method: 'POST', data: data
    })
}


// 种子词库-无效词 - 删除
export function seed_word_invalid_word_deleted(data) {
    return axios({
        url: '/admin/seed_word/invalid_word/deleted', method: 'POST', data: data
    })
}


// 种子词库-词库排除数据 - 列表
export function seed_word_eliminate_word_lists(data) {
    return axios({
        url: '/admin/seed_word/eliminate_word/lists', method: 'POST', data: data
    })
}


// 种子词库-词库排除数据 - 导入
export function seed_word_eliminate_word_import(data) {
    return axios({
        url: '/admin/seed_word/eliminate_word/import', method: 'POST', data: data
    })
}


// 种子词库-词库排除数据 - 导出
export function seed_word_eliminate_word_export(data) {
    return axios({
        url: '/admin/seed_word/eliminate_word/export', method: 'POST', data: data
    })
}


// 种子词库-词库排除数据 - 删除
export function seed_word_eliminate_word_deleted(data) {
    return axios({
        url: '/admin/seed_word/eliminate_word/deleted', method: 'POST', data: data
    })
}


// 种子词库-核心词根 - 列表
export function seed_word_core_etyma_lists(data) {
    return axios({
        url: '/admin/seed_word/core_etyma/lists', method: 'POST', data: data
    })
}


// 种子词库-核心词根 - 导入
export function seed_word_core_etyma_import(data) {
    return axios({
        url: '/admin/seed_word/core_etyma/import', method: 'POST', data: data
    })
}


// 种子词库-核心词根 - 导出
export function seed_word_core_etyma_export(data) {
    return axios({
        url: '/admin/seed_word/core_etyma/export', method: 'POST', data: data
    })
}


// 种子词库-核心词根 - 删除
export function seed_word_core_etyma_deleted(data) {
    return axios({
        url: '/admin/seed_word/core_etyma/deleted', method: 'POST', data: data
    })
}


// 种子词库-对比asin - 列表
export function seed_word_compare_asin_lists(data) {
    return axios({
        url: '/admin/seed_word/compare_asin/lists', method: 'POST', data: data
    })
}


// 种子词库-对比asin - 删除
export function seed_word_compare_asin_deleted(data) {
    return axios({
        url: '/admin/seed_word/compare_asin/deleted', method: 'POST', data: data
    })
}


// 种子词库-列表-添加单复数数据
export function seed_word_asin_list_add_singular_plural(data) {
    return axios({
        url: '/admin/seed_word/asin_list/add_singular_plural', method: 'POST', data: data
    })
}


// 种子词库-列表-更新单复数数据
export function seed_word_asin_list_update_singular_plural(data) {
    return axios({
        url: '/admin/seed_word/asin_list/update_singular_plural', method: 'POST', data: data
    })
}


// 种子词库-列表-单复数列表
export function seed_word_asin_list_get_singular_plural_list(data) {
    return axios({
        url: '/admin/seed_word/asin_list/get_singular_plural_list', method: 'POST', data: data
    })
}

// 管理员功能-获取种子词库人员
export function manager_index_get_seed_word_user_list(data) {
    return axios({
        url: '/admin/manager/index/get_seed_word_user_list', method: 'POST', data: data
    })
}

// 删除
export function seed_word_asin_list_deleted(data) {
    return axios({
        url: '/admin/seed_word/asin_list/deleted', method: 'POST', data: data
    })
}

// 刷新广告组合流量词
export function seed_word_task_update_traffic_word(data) {
    return axios({
        url: '/callback/seed_word_task/update_traffic_word', method: 'POST', data: data
    })
}

// 种子词库-Auto优化Acos的Excel - 列表
export function auto_optimize_acos_excel_list_lists(data) {
    return axios({
        url: '/admin/seed_word/optimize_acos_excel_list/lists', method: 'POST', data: data
    })
}

// 种子词库-Auto优化Acos的Excel - 删除
export function auto_optimize_acos_excel_list_delete(data) {
    return axios({
        url: '/admin/seed_word/auto_optimize_acos_excel_list/deleted', method: 'POST', data: data
    })
}

// 种子词库-Auto优化Acos的Excel - 更新当日
export function operating_asin_task_crontab_create_auto_optimize_acos(data) {
    return axios({
        url: '/callback/seed_word_task/crontab_create_optimize_acos', method: 'POST', data: data
    })
}

// 导出
export function seed_word_asin_list_export(data) {
    return axios({
        url: '/admin/seed_word/asin_list/export', method: 'POST', data: data
    })
}


